MOVE.SRP.OptimizationCritical = (function(SRP) {
  SRP.OptimizationCritical = {
  };
  return SRP.OptimizationCritical;
})(MOVE.SRP || {});



// WEBPACK FOOTER //
// ./srp/critical_components/_optimization_critical.js